export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/b3dc542ec1b5794376b3d1da54a4e35b.svg";